import { TrashIcon } from '@heroicons/react/24/outline';
import { Button } from '@main/complykit/components/button';

type DomainRemoveButtonProps = {
  label: string;
  onClick: () => void;
  isLoading: boolean;
};

export const DomainRemoveButton = ({ label, onClick, isLoading }: DomainRemoveButtonProps) => (
  <Button
    variant="outline"
    tone="critical"
    iconStart={TrashIcon}
    isPending={isLoading}
    onPress={onClick}
  >
    {label}
  </Button>
);
